import { render, staticRenderFns } from "./ProfilePicture.vue?vue&type=template&id=0319adde&scoped=true&"
import script from "./ProfilePicture.vue?vue&type=script&lang=ts&"
export * from "./ProfilePicture.vue?vue&type=script&lang=ts&"
import style0 from "./ProfilePicture.vue?vue&type=style&index=0&id=0319adde&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0319adde",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VImg})
